import _ from "lodash";
import React from "react";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";

import "./WeekDaysList.scss";
import { useSchedulerContext } from "../../../SchedulerContext";

const WEEK_LIST = {
  MO: "week_day_monday",
  TU: "week_day_tuesday",
  WE: "week_day_wednesday",
  TH: "week_day_thursday",
  FR: "week_day_friday",
  SA: "week_day_saturday",
  SU: "week_day_sunday",
};

export const WeekDaysList = ({ days, type }) => {
  const { weekdays } = useSchedulerContext();

  return (
    <ul className={`week-day-list week-day-list--${type}`}>
      {_.map(weekdays, (key) => (
        <li
          key={key}
          data-testid={key}
          className={classNames("week-day-list__day", {
            "week-day-list__day--active": days.includes(key),
          })}
        >
          <span aria-hidden={true}>
            <FormattedMessage id={WEEK_LIST[key]} />
          </span>
          <span className={"sr-only"}>
            <span>
              <FormattedMessage id={key} />
            </span>
            {days.includes(key) && (
              <span>
                <FormattedMessage id="day_selected_aria" />
              </span>
            )}
          </span>
        </li>
      ))}
    </ul>
  );
};
